import { useState } from "react";
import { Row } from "@commonlibs";
import { RadioButtonRoot } from "./RadioButtonGroup.styles";

interface RadioButtonOption {
    label: string;
    value: string;
}

interface RadioButtonGroupProps {
    options: RadioButtonOption[];
    direction?: "row" | "column";
    gap?: string | number;
    defaultValue?: string;
    onChange?: (value: string) => void;
}

export const RadioButtonGroup = ({ options, direction = "row", gap = 20, defaultValue, onChange }: RadioButtonGroupProps) => {
    const [selected, setSelected] = useState<string | undefined>(defaultValue);

    const handleSelect = (value: string) => {
        setSelected(value);
        onChange?.(value);
    };

    return (
        <Row css={{ flexDirection: direction, gap: gap, paddingBottom: "2px" }}> {/* skipcq: JS-0240 */}
            {options.map((item) => (
                <RadioButtonRoot
                    key={item.value}
                    label={item.label}
                    value={selected === item.value}
                    onChange={() => handleSelect(item.value)}
                />
            ))}
        </Row>
    );
};
